module.exports = require("github:harvesthq/chosen@1.6.2/chosen.jquery");